var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 offset-md-4 text-right center" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-primary",
                attrs: { to: "/admin/resources", role: "button" }
              },
              [_vm._v("\n                    back\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.resource
        ? _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.createResource.apply(null, arguments)
                }
              }
            },
            [
              _c("div", { staticClass: "row justify-content-md-center" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _vm.resourceType.length
                      ? _c(
                          "div",
                          { staticClass: "col-md-4" },
                          [
                            _c("fg-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.rules.resourceType,
                                  expression: "rules.resourceType"
                                }
                              ],
                              attrs: {
                                label: "Resource Type",
                                "data-vv-name": "Resource Type",
                                "cus-name": "Resource Type",
                                "has-errors": _vm.errors,
                                "is-fields": _vm.fields,
                                list: _vm.resourceType,
                                selectedKey: "id"
                              },
                              model: {
                                value: _vm.resource.resourceType,
                                callback: function($$v) {
                                  _vm.$set(_vm.resource, "resourceType", $$v)
                                },
                                expression: "resource.resourceType"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-8" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.designation,
                              expression: "rules.designation"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Image URL",
                            placeholder: "Enter URL",
                            "data-vv-name": "designation",
                            "cus-name": "designation",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.resource.imageUrl,
                            callback: function($$v) {
                              _vm.$set(_vm.resource, "imageUrl", $$v)
                            },
                            expression: "resource.imageUrl"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Article/Advertisement Header",
                            placeholder: "Enter Header"
                          },
                          model: {
                            value: _vm.resource.articleHeader,
                            callback: function($$v) {
                              _vm.$set(_vm.resource, "articleHeader", $$v)
                            },
                            expression: "resource.articleHeader"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        !_vm.isAdvertisement
                          ? _c("fg-input", {
                              attrs: {
                                type: "text",
                                label: "Article URL",
                                placeholder: "Enter URL"
                              },
                              model: {
                                value: _vm.resource.articleUrl,
                                callback: function($$v) {
                                  _vm.$set(_vm.resource, "articleUrl", $$v)
                                },
                                expression: "resource.articleUrl"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    !_vm.isAdvertisement
                      ? _c(
                          "div",
                          { staticClass: "col-md-12" },
                          [
                            _c("fg-text-area", {
                              attrs: {
                                rows: "5",
                                label: "Description",
                                placeholder: "Description"
                              },
                              model: {
                                value: _vm.resource.description,
                                callback: function($$v) {
                                  _vm.$set(_vm.resource, "description", $$v)
                                },
                                expression: "resource.description"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isAdvertisement
                      ? _c(
                          "div",
                          { staticClass: "col-md-6" },
                          [
                            _c("fg-input", {
                              attrs: {
                                type: "text",
                                label: "Video Code (Optional)",
                                placeholder: "Enter Video Code"
                              },
                              model: {
                                value: _vm.resource.videoCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.resource, "videoCode", $$v)
                                },
                                expression: "resource.videoCode"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.status.length
                      ? _c(
                          "div",
                          { staticClass: "col-md-6" },
                          [
                            _c("fg-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.rules.status,
                                  expression: "rules.status"
                                }
                              ],
                              attrs: {
                                label: "Status",
                                "data-vv-name": "Status",
                                "cus-name": "Status",
                                "has-errors": _vm.errors,
                                "is-fields": _vm.fields,
                                list: _vm.status,
                                selectedKey: "id"
                              },
                              model: {
                                value: _vm.resource.active,
                                callback: function($$v) {
                                  _vm.$set(_vm.resource, "active", $$v)
                                },
                                expression: "resource.active"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 text-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-fill btn-block",
                      attrs: { type: "submit", disabled: _vm.errors.any() }
                    },
                    [_vm._v("\n              Create Resource\n            ")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" })
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("Create Resource")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d9a5e40", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d9a5e40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Resources/CreateResource.vue
// module id = 9ud5
// module chunks = 0